<template>
    <svg
        id="Folder_closed"
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="15.711"
        viewBox="0 0 21 15.711"
    >
        <path
            id="Pfad_417"
            data-name="Pfad 417"
            d="M364.481,325.158H347.4a1.066,1.066,0,0,1-1.05-1.079l-.907-7.68a1.079,1.079,0,0,1,1.046-1.148h18.9a1.066,1.066,0,0,1,1.05,1.079l-.915,7.819A1.047,1.047,0,0,1,364.481,325.158Zm-.136-1.1a.08.08,0,0,0,0,.019Zm-16.816-.091h16.826l.881-7.53h-18.6Z"
            transform="translate(-345.442 -309.447)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_418"
            data-name="Pfad 418"
            d="M364.895,314.92a.6.6,0,0,1-.594-.594V310.71a57.984,57.984,0,0,1-9.475-.538,9.205,9.205,0,0,1-1.844-.529,6.064,6.064,0,0,0-2.572-.518c-.442.024-1.776.236-2.079.873a1.239,1.239,0,0,0-.078.2v4.133a.594.594,0,1,1-1.189,0l.02-4.368a2.483,2.483,0,0,1,.182-.489c.651-1.369,2.837-1.519,3.084-1.533a7.137,7.137,0,0,1,3.043.591A8.159,8.159,0,0,0,355,309a57.241,57.241,0,0,0,9.406.521,1.006,1.006,0,0,1,.735.284,1.145,1.145,0,0,1,.344.827v3.7A.6.6,0,0,1,364.895,314.92Zm-.438-4.216h0Z"
            transform="translate(-345.778 -307.928)"
            :class="fillClass + ' transition-fill'"
        />
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "FolderIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
            default: "fill-white",
        },
    },
});
</script>
